<template>
  <el-select
    v-model="selectID"
    @change="selectChange"
    :multiple="multiple"
    :disabled="disabled"
    collapse-tags
    placeholder="请选择">
    <el-option
      v-for="item in dataList"
      :key="item.roleId"
      :label="item.roleName"
      :value="item.roleId">
    </el-option>
  </el-select>
</template>

<script>

  export default {
    data() {
      return {
        selectID: this.roleId,
        dataList: [],
      }
    },
    props: {
      roleId: {
        type: [Number,Array],
        default: null
      },
      multiple: {
        type: Boolean,
        default: true
      },
      disabled: Boolean,
    },
    watch: {
      userId: function (newVal, oldVal) {
        this.selectID = newVal;
      },
      selectID : function(newVal, oldVal){
        this.$emit("update:roleId", newVal);
      }
    },
    created() {
      this.getDataList();
    },
    methods: {
      selectChange(event, item) {
        this.$emit('select', event, item);
      },
      getDataList() {
        this.$http({
          url: this.$http.adornUrl('/sys/role/list'),
          method: 'post',
          data: this.$http.adornData({pageIndex:-1,pageSize:-1}),
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.dataList = data.data.list
          } else {
            this.$message.error(data.msg)
          }
        }).catch((err) => {
          this.$message.error(err)
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/role-select.vue